/*
 * @Author: LiuJunQin
 * @Date: 2021-05-27 10:12:44
 * @LastEditors: LiuJunQin
 * @LastEditTime: 2021-05-27 10:14:25
 * @Description: 
 */
import Vue from 'vue'
import Icons from './icon.vue'

Vue.component('icons', Icons)